import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from './translation.ko.json';
import en from './translation.en.json';
import ja from './translation.ja.json';
import es from './translation.es.json';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ko: {
    translation: ko
  },
  en: {
    translation: en
  },
  ja: {
    translation: ja
  },
  es: {
    translation: es
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: { order: ['navigator'] },
    // lng: 'ko',
    fallbackLng: 'en'
  });

export default i18n;
